import 'objectFitPolyfill';
import 'focus-visible';

import './features/detect';
import './features/no-transition-on-resize';
import './features/inner-height-variable';

import './views/menu';
import './views/exhibition-top-spacing';
import './views/exhibition-search';
import './views/exhibition-view-options';
import './views/exhibition-sign-language-video';
import './views/exhibition-audio';
import './views/exhibition-language-switcher';

import './view-initalizer';
